import { Route, Routes } from "react-router-dom";

import EmailTemplateListScreen from "screens/App/CRM/EmailTemplate/EmailTemplateListScreen";
import EmailTemplateEditScreen from "screens/App/CRM/EmailTemplate/EmailTemplateEditScreen";
import EmailTemplateDetailScreen from "screens/App/CRM/EmailTemplate/EmailTemplateDetailScreen";

const EmailTemplateRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<EmailTemplateListScreen />} />
      <Route path=":id/edit" element={<EmailTemplateEditScreen />} />
      <Route path=":id/detail" element={<EmailTemplateDetailScreen />} />
      

    </Routes>
  );
};

export default EmailTemplateRouter;
